import { InputOTP, InputOTPGroup, InputOTPSeparator, InputOTPSlot } from './input-otp';

interface Props {
    id?: string;
    value: string;
    onChange: (value: string) => void;
    length?: 4 | 6;
    size?: 'sm' | 'md' | 'lg';
    disabled?: boolean;
}

const SIZE_CLASS: Record<NonNullable<Props['size']>, string> = {
    sm: 'h-9 w-9 text-base',
    md: 'h-11 w-11 text-lg',
    lg: 'h-12 w-12 text-xl',
};

/**
 * Wraps shadcn's InputOTP with a 3-3 layout matching the Vue OtpCodeInput
 * component. Defaults to 6 digits.
 */
export function OtpCodeInput({ id, value, onChange, length = 6, size = 'md', disabled }: Props) {
    const slotClass = SIZE_CLASS[size];
    const half = Math.floor(length / 2);
    return (
        <InputOTP id={id} value={value} onChange={onChange} maxLength={length} disabled={disabled}>
            <InputOTPGroup>
                {Array.from({ length: half }).map((_, i) => (
                    <InputOTPSlot key={i} index={i} className={slotClass} />
                ))}
            </InputOTPGroup>
            <InputOTPSeparator />
            <InputOTPGroup>
                {Array.from({ length: length - half }).map((_, i) => (
                    <InputOTPSlot key={i + half} index={i + half} className={slotClass} />
                ))}
            </InputOTPGroup>
        </InputOTP>
    );
}
